import { render } from "./AkanezoranoPlanetariumScreen.vue?vue&type=template&id=39bcfa80&scoped=true&ts=true&lang=pug"
import script from "./AkanezoranoPlanetariumScreen.vue?vue&type=script&lang=ts"
export * from "./AkanezoranoPlanetariumScreen.vue?vue&type=script&lang=ts"

import "./AkanezoranoPlanetariumScreen.vue?vue&type=style&index=0&id=39bcfa80&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bcfa80"]])

export default __exports__